module.exports = __webpack_public_path__ + "app-static/img/06.520fdff2.png";